<!-- Header/Navigation -->
<app-navigation></app-navigation>

<!-- Hero Section optimizado para chatbot WhatsApp -->
<section class="hero-chatbot">
  <div class="container">
    <div class="hero-content">
      <div class="hero-text">
        <h1 class="hero-title">
          <span class="chatbot-highlight">Chatbot WhatsApp</span> con IA que Convierte Visitantes en Clientes 24/7
        </h1>
        <p class="hero-subtitle">
          Automatiza tu atención al cliente y aumenta tus ventas con nuestro chatbot WhatsApp con IA personalizado. 
          Desarrollado especialmente para tu negocio en México. El chatbot WhatsApp con IA más completo del mercado.
        </p>
        
        <!-- Social proof -->
        <div class="social-proof">
          <div class="proof-item">
            <img src="icons/check-solid.svg" alt="" class="proof-icon" width="18" height="18">
            <span>+50 empresas mexicanas confían</span>
          </div>
          <div class="proof-item">
            <img src="icons/robot-solid-full.svg" alt="" class="proof-icon" width="18" height="18">
            <span>Chatbot WhatsApp con IA GPT-4</span>
          </div>
          <div class="proof-item">
            <img src="icons/mobile-button-solid-full.svg" alt="" class="proof-icon" width="18" height="18">
            <span>WhatsApp Business API oficial</span>
          </div>
        </div>

        <div class="hero-actions">
          <button (click)="scrollToSection('contact-form')" class="btn-primary-chatbot">
            <img src="icons/fire-solid-full.svg" alt="" class="btn-icon" width="18" height="18">
            Cotizar Mi Chatbot
          </button>
          <button (click)="openWhatsApp()" class="btn-secondary-chatbot">
            <img src="icons/whatsapp.svg" alt="" class="btn-icon" width="18" height="18">
            Hablar por WhatsApp
          </button>
        </div>
      </div>

      <div class="hero-visual">
        <!-- Mockup de conversación WhatsApp -->
        <div class="whatsapp-mockup">
          <div class="mockup-header">
            <div class="mockup-avatar">
              <img src="icons/user-solid-full.svg" alt="" class="avatar-icon" width="24" height="24">
            </div>
            <div class="mockup-info">
              <div class="contact-name">Cliente Potencial</div>
              <span class="status-online"><span class="status-dot"></span> En línea</span>
            </div>
          </div>
          
          <div class="mockup-messages">
            <div class="message-received">
              <p>Hola, me interesa un sistema para mi restaurante</p>
              <span class="message-time">10:30</span>
            </div>
            
            <div class="message-sent">
              <p>¡Perfecto! Te ayudo con eso. ¿Cuántas mesas manejas? Nuestro sistema para restaurantes incluye:</p>
              <ul>
                <li>Gestión de pedidos</li>
                <li>Control de inventario</li>
                <li>Reportes de ventas</li>
              </ul>
              <span class="message-time">10:31</span>
            </div>

            <div class="message-received">
              <p>Tenemos 15 mesas. ¿Cuánto cuesta?</p>
              <span class="message-time">10:32</span>
            </div>

            <div class="message-sent">
              <p>Te agendo una demo personalizada. ¿Prefieres mañana en la mañana o tarde?</p>
              <span class="message-time">10:33 ✓✓</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Comparación vs competencia (oculta temporalmente) -->
<!-- <section class="comparison-section">
  <div class="container">
    <div class="section-header">
      <h2>Compara nuestro <strong>chatbot WhatsApp con IA</strong> con otras opciones</h2>
      <p>Análisis detallado: chatbot WhatsApp personalizado vs. soluciones genéricas</p>
    </div>

    <div class="comparison-table">
      <table class="table-responsive">
        <thead>
          <tr>
            <th>Característica</th>
            <th class="highlight-column">
              <img src="icons/star-solid-full.svg" alt="Mejor opción" class="table-icon" width="20" height="20">
              Chatbot Pezeta
            </th>
            <th>Cliengo</th>
            <th>Kommo</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><strong>Precio mensual</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              Desde $999 MXN/mes
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              Desde $45 USD/mes (~$900 MXN)
            </td>
            <td>
              <img src="icons/xmark-solid-full.svg" alt="No incluido" class="cross-icon" width="18" height="18">
              Desde $15 USD/usuario/mes
            </td>
          </tr>
          <tr>
            <td><strong>Conversaciones/mes</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              1,000 - Ilimitadas
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              500 - 4,000 (según plan)
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              Sin límite, pero cobro por usuario
            </td>
          </tr>
          <tr>
            <td><strong>Usuarios incluidos</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              5 - Ilimitados (precio fijo)
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              2 - 5 agentes (según plan)
            </td>
            <td>
              <img src="icons/xmark-solid-full.svg" alt="No incluido" class="cross-icon" width="18" height="18">
              Cobro por usuario ($15-45 USD c/u)
            </td>
          </tr>
          <tr>
            <td><strong>CRM Integrado</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              Incluido en todos los planes
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              Solo plan Corporate
            </td>
            <td>
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              Es su producto principal
            </td>
          </tr>
          <tr>
            <td><strong>IA Conversacional</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              GPT-4 en todos los planes
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              IA Copilot (planes Premium+)
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              Funciones básicas; AI Agent es addon
            </td>
          </tr>
          <tr>
            <td><strong>WhatsApp API</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              Incluido en todos los planes
            </td>
            <td>
              <img src="icons/xmark-solid-full.svg" alt="No incluido" class="cross-icon" width="18" height="18">
              Solo plan Business ($259 USD)
            </td>
            <td>
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              Incluido
            </td>
          </tr>
          <tr>
            <td><strong>Soporte en español</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              100% mexicano (Los Mochis)
            </td>
            <td>
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              Argentina/Latam
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              Internacional (109 países)
            </td>
          </tr>
          <tr>
            <td><strong>Personalización</strong></td>
            <td class="highlight-column">
              <img src="icons/check-solid.svg" alt="Incluido" class="check-icon" width="18" height="18">
              Entrenamiento personalizado
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              Chatbots programables
            </td>
            <td>
              <img src="icons/triangle-exclamation-solid.svg" alt="Parcial" class="warning-icon" width="18" height="18">
              Pipelines personalizables
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section> -->

<!-- Características Destacadas -->
<section class="highlighted-features-section">
  <div class="container">
    <div class="section-header">
      <h2>¿Por qué <strong>Chatbot Pezeta</strong> es diferente?</h2>
      <p>No somos un bot de menús. Somos una IA conversacional que entiende, responde y vende como tu mejor vendedor.</p>
    </div>

    <div class="highlighted-features-grid">
      <!-- Conversacional Inteligente -->
      <div class="highlight-card primary">
        <div class="highlight-icon-wrapper">
          <img src="icons/comments-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Conversación Natural</h3>
        <p>Nada de "Presiona 1 para ventas, 2 para soporte". Nuestro chatbot mantiene conversaciones fluidas y naturales, como si hablara con una persona real.</p>
        <div class="highlight-badge">Sin menús robóticos</div>
      </div>

      <!-- Interpreta Imágenes -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/image-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Interpreta Imágenes</h3>
        <p>El cliente envía una foto del producto que busca y el chatbot lo identifica, sugiere opciones similares o confirma disponibilidad.</p>
      </div>

      <!-- Procesa Audios -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/circle-play-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Procesa Audios</h3>
        <p>¿El cliente prefiere hablar? El bot transcribe y entiende mensajes de voz, respondiendo de forma inteligente a lo que escucha.</p>
      </div>

      <!-- Califica y Segmenta Leads -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/star-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Califica y Segmenta Leads</h3>
        <p>Automáticamente clasifica cada prospecto según interés, presupuesto y urgencia. Tu equipo de ventas solo atiende leads calificados.</p>
      </div>

      <!-- Intervención Humana -->
      <div class="highlight-card primary">
        <div class="highlight-icon-wrapper">
          <img src="icons/people-arrows-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Intervención Humana</h3>
        <p>Plataforma completa para que tu equipo tome el control cuando sea necesario. El chatbot pasa la conversación sin interrumpir la experiencia del cliente.</p>
        <div class="highlight-badge">Handoff inteligente</div>
      </div>

      <!-- Resumen de Conversación -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/list-solid.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Resumen Automático</h3>
        <p>Genera un resumen completo de cada conversación: qué preguntó el cliente, qué se le ofreció, objeciones y siguiente paso recomendado.</p>
      </div>

      <!-- Notificaciones -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/bullhorn-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Notificaciones Inteligentes</h3>
        <p>Alerta a administradores cuando detecta leads calientes, quejas urgentes o situaciones que requieren atención inmediata.</p>
      </div>

      <!-- CRM Integrado -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/address-card-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>CRM Integrado</h3>
        <p>Cada lead se guarda automáticamente con historial completo, datos de contacto, preferencias y etapa en el embudo de ventas.</p>
      </div>

      <!-- Multicanal -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/shuffle-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>WhatsApp + Web Chat</h3>
        <p>Un solo chatbot que atiende WhatsApp y tu página web con el mismo entrenamiento. Widget instalable en cualquier sitio.</p>
      </div>

      <!-- Entrenamiento Personalizado -->
      <div class="highlight-card primary">
        <div class="highlight-icon-wrapper">
          <img src="icons/lightbulb-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Entrenamiento a tu Medida</h3>
        <p>El bot conoce tus productos, precios, políticas y forma de hablar. Responde exactamente como tú lo harías, con tu personalidad de marca.</p>
        <div class="highlight-badge">100% personalizado</div>
      </div>

      <!-- Analytics -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/chart-pie-solid-full.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Analytics en Tiempo Real</h3>
        <p>Dashboard con métricas de conversaciones, tasa de conversión, preguntas frecuentes y rendimiento del chatbot.</p>
      </div>

      <!-- Remarketing -->
      <div class="highlight-card">
        <div class="highlight-icon-wrapper">
          <img src="icons/envelope-solid.svg" alt="" class="highlight-icon" width="32" height="32">
        </div>
        <h3>Remarketing Automatizado</h3>
        <p>Recontacta leads fríos con mensajes personalizados. El bot retoma conversaciones abandonadas de forma natural.</p>
      </div>
    </div>
  </div>
</section>

<!-- Pricing Section -->
<section id="pricing" class="pricing-section">
  <div class="container">
    <div class="section-header">
      <h2>Planes y <strong>Precios</strong></h2>
      <p>Elige el plan perfecto para tu negocio. Todos incluyen IA GPT-4.</p>
    </div>

    <!-- Billing Period Toggle -->
    <div class="billing-toggle">
      <button
        class="toggle-btn"
        [class.active]="billingPeriod === 'monthly'"
        (click)="toggleBillingPeriod('monthly')">
        Mensual
      </button>
      <button
        class="toggle-btn"
        [class.active]="billingPeriod === 'yearly'"
        (click)="toggleBillingPeriod('yearly')">
        Anual
        <span class="discount-badge">-{{ yearlyDiscountPercent }}%</span>
      </button>
    </div>

    <div class="pricing-grid" *ngIf="!plansLoading && !plansError">
      <div *ngFor="let plan of plans"
           class="pricing-card"
           [class.featured]="plan.code === 'PROFESSIONAL'">

        <div class="plan-badge" *ngIf="plan.code === 'PROFESSIONAL'">
          Más Popular
        </div>

        <div class="plan-header">
          <h3 class="plan-name">{{ plan.name }}</h3>

          <!-- Precio original tachado (solo en anual) -->
          <div class="original-price" *ngIf="billingPeriod === 'yearly'">
            <span class="strikethrough">${{ getOriginalMonthlyPrice(plan) | number:'1.0-0' }}</span>
          </div>

          <div class="plan-price">
            <span class="currency">$</span>
            <span class="amount">{{ getPriceMXN(plan) | number:'1.0-0' }}</span>
            <span class="currency-label">MXN</span>
            <span class="period">/mes</span>
          </div>

          <!-- Total anual (solo en anual) -->
          <div class="yearly-total" *ngIf="billingPeriod === 'yearly'">
            ${{ getYearlyTotal(plan) | number:'1.0-0' }} MXN/año
          </div>

          <p class="plan-description">{{ plan.description }}</p>
        </div>

        <ul class="plan-features">
          <!-- Límites del plan -->
          <li>
            <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
            <span *ngIf="plan.defaultMonthlyMessageLimit === -1">Mensajes ilimitados</span>
            <span *ngIf="plan.defaultMonthlyMessageLimit !== -1">{{ plan.defaultMonthlyMessageLimit | number }} mensajes/mes</span>
          </li>
          <li>
            <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
            <span *ngIf="plan.defaultMaxUsers === -1">Usuarios ilimitados</span>
            <span *ngIf="plan.defaultMaxUsers !== -1">Hasta {{ plan.defaultMaxUsers }} usuarios</span>
          </li>
          <li>
            <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
            <span *ngIf="plan.defaultMaxLeads === -1">Leads ilimitados</span>
            <span *ngIf="plan.defaultMaxLeads !== -1">Hasta {{ plan.defaultMaxLeads | number }} leads</span>
          </li>

          <!-- BASIC: Mostrar características completas -->
          <ng-container *ngIf="plan.code === 'BASIC'">
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Chatbot IA conversacional
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Plataforma de monitoreo
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Intervención humana
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Interpreta imágenes y audios
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Envío de catálogo/productos
            </li>
            <li class="feature-not-included">
              <img src="icons/xmark-solid-full.svg" alt="No incluido" class="feature-cross-icon" width="16" height="16">
              CRM integrado
            </li>
            <li class="feature-not-included">
              <img src="icons/xmark-solid-full.svg" alt="No incluido" class="feature-cross-icon" width="16" height="16">
              Calificación de leads
            </li>
          </ng-container>

          <!-- PROFESSIONAL: Todo lo de Basic + características propias -->
          <ng-container *ngIf="plan.code === 'PROFESSIONAL'">
            <li class="feature-inherit">
              <img src="icons/star-solid-full.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Todo lo de Basic +
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Agendamiento de citas
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              CRM integrado
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Calificación de leads
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Resumen automático
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Notificaciones inteligentes
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Envío de galerías de imágenes
            </li>
          </ng-container>

          <!-- ENTERPRISE: Todo lo de Professional + características propias -->
          <ng-container *ngIf="plan.code === 'ENTERPRISE'">
            <li class="feature-inherit">
              <img src="icons/star-solid-full.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Todo lo de Professional +
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Analytics avanzados
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Remarketing automatizado
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              WhatsApp + Web Chat
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Campañas masivas WhatsApp
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Segmentación de audiencias
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Plantillas WhatsApp personalizadas
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Soporte prioritario
            </li>
            <li>
              <img src="icons/check-solid.svg" alt="Incluido" class="feature-check-icon" width="16" height="16">
              Webhooks personalizados
            </li>
          </ng-container>
        </ul>

        <button (click)="scrollToSection('contact-form')" class="plan-cta">
          Contactar Ventas
        </button>
      </div>
    </div>

    <div *ngIf="plansLoading" class="pricing-loader">
      <div class="loader-spinner"></div>
      <p>Cargando planes...</p>
    </div>

    <div *ngIf="plansError" class="pricing-error">
      <p>Error al cargar planes. Contáctanos directamente.</p>
      <button (click)="openWhatsApp()" class="btn-secondary-chatbot">
        Contactar por WhatsApp
      </button>
    </div>
  </div>
</section>

<!-- Casos de uso -->
<section class="use-cases-section">
  <div class="container">
    <div class="section-header">
      <h2>Casos de éxito de nuestro <strong>chatbot WhatsApp con IA</strong></h2>
      <p>Empresas mexicanas reales que han transformado sus ventas con nuestro chatbot WhatsApp automatizado</p>
    </div>

    <div class="use-cases-grid">
      <div class="use-case-card">
        <div class="case-header">
          <img src="icons/store-solid-full.svg" alt="" class="case-icon" width="28" height="28">
          <h3>Restaurante en Guadalajara</h3>
        </div>
        <div class="case-metrics">
          <div class="metric">
            <span class="metric-number">+150%</span>
            <span class="metric-label">Reservas</span>
          </div>
          <div class="metric">
            <span class="metric-number">-70%</span>
            <span class="metric-label">Tiempo respuesta</span>
          </div>
        </div>
        <p>"Nuestro chatbot WhatsApp con IA maneja las reservas automáticamente. Los clientes pueden hacer reservas las 24 horas sin intervención humana."</p>
      </div>

      <div class="use-case-card">
        <div class="case-header">
          <img src="icons/building-solid-full.svg" alt="" class="case-icon" width="28" height="28">
          <h3>Inmobiliaria CDMX</h3>
        </div>
        <div class="case-metrics">
          <div class="metric">
            <span class="metric-number">+80%</span>
            <span class="metric-label">Leads calificados</span>
          </div>
          <div class="metric">
            <span class="metric-number">35%</span>
            <span class="metric-label">Más ventas</span>
          </div>
        </div>
        <p>"El chatbot WhatsApp califica automáticamente a los prospectos y agenda citas con nuestros asesores mediante IA inteligente en México."</p>
      </div>

      <div class="use-case-card">
        <div class="case-header">
          <img src="icons/cart-shopping-solid-full.svg" alt="" class="case-icon" width="28" height="28">
          <h3>E-commerce Monterrey</h3>
        </div>
        <div class="case-metrics">
          <div class="metric">
            <span class="metric-number">24/7</span>
            <span class="metric-label">Atención</span>
          </div>
          <div class="metric">
            <span class="metric-number">-60%</span>
            <span class="metric-label">Carritos abandonados</span>
          </div>
        </div>
        <p>"Recuperamos ventas perdidas. El chatbot WhatsApp con IA contacta automáticamente a clientes con carrito abandonado usando mensajería automatizada en México."</p>
      </div>
    </div>
  </div>
</section>

<!-- FAQ optimizada para SEO -->
<section class="faq-section">
  <div class="container">
    <div class="section-header">
      <h2>Preguntas frecuentes sobre <strong>chatbot WhatsApp con IA</strong></h2>
    </div>

    <div class="faq-grid">
      <div class="faq-item">
        <h3 class="faq-question">
          <img src="icons/robot-solid-full.svg" alt="" class="faq-icon" width="20" height="20">
          ¿Qué es un chatbot WhatsApp con IA personalizado?
        </h3>
        <p class="faq-answer">
          Un chatbot WhatsApp con IA personalizado es un asistente virtual desarrollado específicamente para tu negocio en México,
          que responde automáticamente a tus clientes las 24 horas usando la plataforma WhatsApp Business API.
          A diferencia de soluciones genéricas, nuestro bot WhatsApp automático está entrenado con información específica de tu empresa.
        </p>
      </div>

      <div class="faq-item">
        <h3 class="faq-question">
          <img src="icons/tag-solid-full.svg" alt="" class="faq-icon" width="20" height="20">
          ¿Cuánto cuesta el servicio de chatbot WhatsApp con IA?
        </h3>
        <p class="faq-answer">
          Ofrecemos planes desde $999 MXN/mes para pequeñas empresas hasta planes Enterprise
          con recursos ilimitados por $9,999 MXN/mes. Todos incluyen IA GPT-4 y CRM integrado.
        </p>
      </div>

      <div class="faq-item">
        <h3 class="faq-question">
          <img src="icons/mobile-button-solid-full.svg" alt="" class="faq-icon" width="20" height="20">
          ¿Funciona con WhatsApp Business API oficial?
        </h3>
        <p class="faq-answer">
          Sí, nuestro WhatsApp chatbot utiliza exclusivamente la API oficial de WhatsApp Business,
          garantizando estabilidad, seguridad y cumplimiento con las políticas de Meta para cualquier bot de WhatsApp.
        </p>
      </div>

      <div class="faq-item">
        <h3 class="faq-question">
          <img src="icons/clock-solid-full.svg" alt="" class="faq-icon" width="20" height="20">
          ¿Cuánto tiempo toma implementar un chatbot WhatsApp?
        </h3>
        <p class="faq-answer">
          La implementación de un bot para WhatsApp personalizado toma entre 2-4 semanas,
          incluyendo diseño, desarrollo, entrenamiento de IA, pruebas y configuración final del WhatsApp bot.
        </p>
      </div>

      <div class="faq-item">
        <h3 class="faq-question">
          <img src="icons/gear-solid-full.svg" alt="" class="faq-icon" width="20" height="20">
          ¿Incluye soporte técnico después de la entrega?
        </h3>
        <p class="faq-answer">
          Sí, todos los planes incluyen soporte técnico.
          Además ofrecemos actualizaciones continuas y mejoras a la IA incluidas en tu suscripción.
        </p>
      </div>

      <div class="faq-item">
        <h3 class="faq-question">
          <img src="icons/chart-diagram-solid-full.svg" alt="" class="faq-icon" width="20" height="20">
          ¿Se integra con mi CRM o sistema actual?
        </h3>
        <p class="faq-answer">
          Sí, nuestro WhatsApp bot se integra con la mayoría de CRMs populares y
          sistemas empresariales mediante APIs. También incluimos un CRM básico si no tienes uno para tu chatbot para WhatsApp.
        </p>
      </div>
    </div>
  </div>
</section>

<!-- Formulario de contacto -->
<section id="contact-form" class="contact-form-section">
  <div class="container">
    <div class="form-layout">
      <div class="form-info">
        <h2>¿Listo para tu <strong>chatbot WhatsApp con IA</strong>?</h2>
        <p>Agenda tu consultoría gratuita y descubre cómo un chatbot WhatsApp con IA personalizado puede transformar tu negocio en México.</p>
        
        <div class="form-benefits">
          <div class="benefit-item">
            <img src="icons/phone-solid.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Consultoría gratuita de 30 minutos</span>
          </div>
          <div class="benefit-item">
            <img src="icons/chart-simple-solid-full.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Análisis de tu negocio sin costo</span>
          </div>
          <div class="benefit-item">
            <img src="icons/lightbulb-solid-full.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Propuesta personalizada</span>
          </div>
          <div class="benefit-item">
            <img src="icons/bullhorn-solid-full.svg" alt="" class="benefit-icon" width="18" height="18">
            <span>Demo en vivo de nuestro chatbot WhatsApp con IA</span>
          </div>
        </div>

        <div class="trust-indicators">
          <div class="trust-item">
            <img src="icons/lock-solid-full.svg" alt="" class="trust-icon" width="16" height="16">
            <span>Información 100% confidencial</span>
          </div>
          <div class="trust-item">
            <img src="icons/fire-solid-full.svg" alt="" class="trust-icon" width="16" height="16">
            <span>Respuesta en 24 horas</span>
          </div>
          <div class="trust-item">
            <img src="icons/map-pin-solid-full.svg" alt="" class="trust-icon" width="16" height="16">
            <span>Empresa mexicana en Los Mochis</span>
          </div>
        </div>
      </div>

      <div class="form-container">
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()" class="contact-form">
          <div class="form-grid">
            <!-- Fila 1: Nombre completo -->
            <div class="form-group full-width">
              <label for="name">Nombre completo *</label>
              <input 
                type="text" 
                id="name" 
                formControlName="name"
                [class.error]="isFieldInvalid('name')"
                placeholder="Tu nombre completo">
              <span class="error-message" *ngIf="isFieldInvalid('name')">
                {{ getFieldError('name') }}
              </span>
            </div>

            <!-- Fila 2: Email y Teléfono -->
            <div class="form-group">
              <label for="email">Email corporativo *</label>
              <input 
                type="email" 
                id="email" 
                formControlName="email"
                [class.error]="isFieldInvalid('email')"
                placeholder="tu-email@empresa.com">
              <span class="error-message" *ngIf="isFieldInvalid('email')">
                {{ getFieldError('email') }}
              </span>
            </div>

            <div class="form-group">
              <label for="phone">Teléfono *</label>
              <input 
                type="tel" 
                id="phone" 
                formControlName="phone"
                [class.error]="isFieldInvalid('phone')"
                placeholder="668-123-4567">
              <span class="error-message" *ngIf="isFieldInvalid('phone')">
                {{ getFieldError('phone') }}
              </span>
            </div>

            <!-- Fila 3: Descripción del proyecto -->
            <div class="form-group full-width">
              <label for="message">Describe tu proyecto de chatbot WhatsApp *</label>
              <textarea 
                id="message" 
                formControlName="message"
                [class.error]="isFieldInvalid('message')"
                rows="4"
                placeholder="Cuéntanos sobre tu proyecto: qué necesitas, objetivos, desafíos actuales, etc."></textarea>
              <span class="error-message" *ngIf="isFieldInvalid('message')">
                {{ getFieldError('message') }}
              </span>
            </div>
          </div>

          <div class="form-actions">
            <button 
              type="submit" 
              class="btn-submit"
              [disabled]="isSubmitting"
              [class.loading]="isSubmitting">
              <span *ngIf="!isSubmitting">Enviar solicitud</span>
              <span *ngIf="isSubmitting">
                <img src="icons/spinner-solid.svg" alt="" class="spinner-icon" width="16" height="16">
                Enviando...
              </span>
            </button>
          </div>

          <div *ngIf="submitMessage" class="submit-message" [class.success]="submitSuccess" [class.error]="!submitSuccess">
            <img *ngIf="submitSuccess" src="icons/check-solid.svg" alt="" class="status-icon" width="16" height="16">
            <img *ngIf="!submitSuccess" src="icons/triangle-exclamation-solid.svg" alt="" class="status-icon" width="16" height="16">
            {{ submitMessage }}
          </div>
        </form>
      </div>
    </div>
  </div>
</section>

<!-- CTA final -->
<section class="final-cta-section">
  <div class="container">
    <div class="cta-content">
      <h2>¿Listo para automatizar tu negocio con un <strong>chatbot WhatsApp con IA</strong>?</h2>
      <p>Únete a las empresas mexicanas que ya están aprovechando el poder de nuestro chatbot WhatsApp con IA y la automatización inteligente.</p>
      
      <div class="cta-actions">
        <button (click)="scrollToSection('contact-form')" class="btn-primary-cta">
          <img src="icons/comments-solid-full.svg" alt="" class="cta-icon" width="18" height="18">
          Solicitar Demo Gratuita
        </button>
        <button (click)="openWhatsApp()" class="btn-secondary-cta">
          <img src="icons/whatsapp.svg" alt="" class="cta-icon" width="18" height="18">
          Contactar por WhatsApp
        </button>
      </div>

      <div class="final-guarantees">
        <div class="guarantee-item">
          <img src="icons/check-solid.svg" alt="" class="guarantee-icon" width="16" height="16">
          <span>Sin compromiso</span>
        </div>
        <div class="guarantee-item">
          <img src="icons/lock-solid-full.svg" alt="" class="guarantee-icon" width="16" height="16">
          <span>Información confidencial</span>
        </div>
        <div class="guarantee-item">
          <img src="icons/map-pin-solid-full.svg" alt="" class="guarantee-icon" width="16" height="16">
          <span>Empresa 100% mexicana</span>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<app-footer></app-footer>